module.exports = __webpack_public_path__ + "img/kim.e5d62ddf.jpg";